import { render, staticRenderFns } from "./Visits.vue?vue&type=template&id=32fb626f&scoped=true&"
import script from "./Visits.vue?vue&type=script&lang=js&"
export * from "./Visits.vue?vue&type=script&lang=js&"
import style0 from "./Visits.vue?vue&type=style&index=0&id=32fb626f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fb626f",
  null
  
)

export default component.exports